<div class="invest-row {{type}}">
	<div class="grid-x">
    <div class="cell small-8 large-9"><span class="name" [innerHTML]="textkeyPrefix + name | translate: placeholder"></span></div>
		<div class="cell small-3 large-2"><span class="amount" [class.highlight]="amountHighlight">{{(amount * 1) | number: '1.0-0'}} €</span></div>
		<div class="cell small-1 help"><button class="help-button" *ngIf="hasHelp" [attr.aria-expanded]="showHelp" [attr.aria-controls]="name + '-help'" [attr.aria-label]="'arialabel.toggle.help' | translate" (click)="showHelp = !showHelp"><i class="icon-help-circle"></i></button></div>
	</div>
	<div class="callout" *ngIf="showHelp">
    <button type="button" class="close" [attr.aria-label]="'arialabel.close' | translate" (click)="showHelp=false"><i class="icon-x"></i></button>
		<p [id]="name + '-help'" [innerHTML]="textkeyPrefix + name + '.help' | translate: placeholder"></p>
	</div>
</div>
